(() => {
  const STYLE_ID = 'codex-cart-upgrades-style';
  const ENHANCED_ATTR = 'data-codex-cart-enhanced';

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
    `;
    document.head.appendChild(style);
  }

  function looksLikeCartPanel(element) {
    const text = element.innerText || '';
    return text.includes('Subtotal') && text.includes('Terminar pedido');
  }

  function findCartPanel(trigger) {
    let current = trigger.parentElement;
    while (current && current !== document.body) {
      if (looksLikeCartPanel(current)) return current;
      current = current.parentElement;
    }
    return null;
  }

  function enhancePanel(panel) {
    if (!panel || panel.hasAttribute(ENHANCED_ATTR)) return;
    panel.setAttribute(ENHANCED_ATTR, 'true');

    const checkoutButton = Array.from(panel.querySelectorAll('button, a')).find((element) =>
      (element.textContent || '').includes('Terminar pedido')
    );

    if (!checkoutButton) return;

    const note = document.createElement('p');
    note.className = 'codex-cart-checkout-note';
    note.textContent = 'Puedes revisar despacho, retiro y medios de pago antes de confirmar la compra.';
    checkoutButton.insertAdjacentElement('afterend', note);

    const continueLink = document.createElement('a');
    continueLink.className = 'codex-cart-continue-link';
    continueLink.href = '/collections/all';
    continueLink.textContent = 'Seguir comprando';
    note.insertAdjacentElement('afterend', continueLink);
  }

  function enhanceCarts() {
    addStyles();

    const triggers = Array.from(document.querySelectorAll('button, a')).filter((element) =>
      (element.textContent || '').includes('Terminar pedido')
    );

    for (const trigger of triggers) {
      const panel = findCartPanel(trigger);
      enhancePanel(panel);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceCarts, { once: true });
  } else {
    enhanceCarts();
  }

  const observer = new MutationObserver(() => enhanceCarts());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
